
// 1. websocket连接：判断浏览器是否兼容，获取websocket url并连接，这里为了方便本地生成websocket url
// 2. 获取浏览器录音权限：判断浏览器是否兼容，获取浏览器录音权限，
// 3. js获取浏览器录音数据
// 4. 将录音数据处理为文档要求的数据格式：采样率16k或8K、位长16bit、单声道；该操作属于纯数据处理，使用webWork处理
// 5. 根据要求（采用base64编码，每次发送音频间隔40ms，每次发送音频字节数1280B）将处理后的数据通过websocket传给服务器，
// 6. 实时接收websocket返回的数据并进行处理

// ps: 该示例用到了es6中的一些语法，建议在chrome下运行

import CryptoJS from 'crypto-js'
import { Base64 } from './base64js.js'
import parser from 'fast-xml-parser'
import Worker from './transcode.worker.js'
import { getCookie, HttpFactory, zhlType, submitErrorLog } from '@/assets/js/common'

const transWorker = new Worker()

//APPID，APISecret，APIKey在控制台-我的应用-语音评测（流式版）页面获取
// const APPID = '52a92404'
// const API_SECRET = 'MWM5OThjOGU3NTE2YjY1NzViYTBmOGMz'
// const API_KEY = 'ce3e48187919f683a50ce33251babbc9'
const APPID = "7ecd9c58";
const API_SECRET = "NzllMWEwYzY3OTlmMTZhOTEzZjg2ZGUz";
const API_KEY = "64f4d5d6984032b48d353eb2c2e730df";

/**
 * 获取websocket url
 * 该接口需要后端提供，这里为了方便前端处理
 */
function getWebSocketUrl() {
  return new Promise((resolve, reject) => {
    // 请求地址根据语种不同变化
    let url = 'wss://ise-api.xfyun.cn/v2/open-ise'
    const host = 'ise-api.xfyun.cn'
    const apiKey = API_KEY
    const apiSecret = API_SECRET
    const date = new Date().toGMTString()
    const algorithm = 'hmac-sha256'
    const headers = 'host date request-line'
    const signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/open-ise HTTP/1.1`
    const signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
    const signature = CryptoJS.enc.Base64.stringify(signatureSha)
    const authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
    const authorization = btoa(authorizationOrigin)
    url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
    resolve(url)
  })
}
class IseRecorder {
  constructor({ language, accent, appId } = {}) {
    let self = this
    // 要测评的信息
    this.text = ''
    // 中文题型：
    // read_syllable（单字朗读，汉语专有）
    // read_word（词语朗读）
    // read_sentence（句子朗读）
    // read_chapter(篇章朗读)
    // 英文题型：
    // read_word（词语朗读）
    // read_sentence（句子朗读）
    // read_chapter(篇章朗读)
    // simple_expression（英文情景反应）
    // read_choice（英文选择题）
    // topic（英文自由题）
    // retell（英文复述题）
    // picture_talk（英文看图说话）
    // oral_translation（英文口头翻译）
    this.category= 'read_sentence'
    this.status = 'null'
    this.language = language || 'en_us'//'zh_cn'
    this.accent = accent || 'mandarin'
    this.appId = appId || APPID
    // 记录音频数据
    this.audioData = []

    //-音频合成相关变量：start
    //录音文件长度
    this.size = 0
    //录音缓存
    this.buffer = []
    //输入采样率
    this.inputSampleRate = 44100
    //输入采样数位 8, 16
    this.inputSampleBits = 16
    // 输出采样率共分为11025Hz、22050Hz、24000Hz、44100Hz、48000Hz五个等级，
    // 11025Hz能达到AM调幅广播的声音品质，而22050Hz和24000HZ能达到FM调频广播的声音品质，
    // 44100Hz则是理论上的CD音质界限，48000Hz则更加精确一些
    this.outputSampleRate = 44100 / 2
    //输出采样数位 8, 16
    this.oututSampleBits = 8
    //音频合成相关变量：-end
    transWorker.onmessage = function (event) {
      self.audioData.push(...event.data)
    }
    // $('.start-taste-left .ipt').text(`where are you`)
  }

  // 修改录音评测状态
  setStatus(status) {
    this.onWillStatusChange && this.status !== status && this.onWillStatusChange(this.status, status)
    this.status = status
  }
  setResultText(setResultXml = '') {
    const sourceResult = Object.assign({}, setResultXml)
    console.log(sourceResult)
    const read_chapter = sourceResult?.xml_result?.read_sentence?.rec_paper?.read_chapter
    const sentence = read_chapter?.sentence || []
    const resultStr = read_chapter?.content
    const overall = Math.round((Number(read_chapter.total_score) || 0) * 20)
    const standard_score = Math.round((Number(read_chapter.standard_score) || 0) * 20)
    const accuracy_score = Math.round((Number(read_chapter.accuracy_score) || 0) * 20)
    const fluency_score = {
      overall: Math.round((Number(read_chapter.fluency_score) || 0) * 20),
      speed: null
    }
    let wordArr = []
    if (Array.isArray(sentence)) {
      sentence.forEach(v => {
        if (Array.isArray(v.word)) {
          wordArr.push(...v.word)
        } else {
          wordArr.push(v.word)
        }
      })
    } else {
      if (Array.isArray(sentence.word)) {
        wordArr = sentence.word
      } else {
        wordArr = [sentence.word]
      }
    }
    const wordInfosArr = wordArr.map((item) => {
      return {
        score: item.total_score * 20,
        word: item.content
      }
    })
    const result = {
      duration: this.mediaSource.context.currentTime,
      wordInfosArr: wordInfosArr,
      resultStr: resultStr,
      overall: overall,
      standard_score: standard_score,
      accuracy_score: accuracy_score,
      fluency_score: fluency_score
    }
    // this.setAudioUrl(result) // 添加url 参数
    console.log(result)
    this.onTextChange && this.onTextChange(JSON.stringify(result) || '')
  }
  // 修改评测参数
  setParams({ language, accent } = {}) {
    language && (this.language = language)
    accent && (this.accent = accent)
  }
  // 连接websocket
  connectWebSocket() {
    if (APPID === 'APPID' || !APPID) {
      alert('请填写APPID、APISecret、APIKey，可从控制台-我的应用-语音评测（流式版）页面获取。')
      return false;
    }
    return getWebSocketUrl().then(url => {
      let iseWS
      if ('WebSocket' in window) {
        iseWS = new WebSocket(url)
      } else if ('MozWebSocket' in window) {
        iseWS = new MozWebSocket(url)
      } else {
        alert('浏览器不支持WebSocket')
        return
      }
      this.webSocket = iseWS
      this.setStatus('init')
      iseWS.onopen = e => {
        this.setStatus('ing')
        // 重新开始录音
        setTimeout(() => {
          this.webSocketSend()
        }, 50)
      }
      iseWS.onmessage = e => {
        this.result(e.data)
      }
      iseWS.onerror = e => {
        this.recorderStop()
      }
      iseWS.onclose = e => {
        this.recorderStop()
      }
    })
  }
  // 初始化浏览器录音
  recorderInit(testPermission) {
    //-音频合成相关，清空历史:start
    this.buffer = []
    this.size = 0
    //-音频合成相关，清空历史:end
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia

    if(testPermission) {
      const text = testPermission.text
      this.text = text
      // this.category = text.trim().indexOf(' ') !== -1 ? 'read_sentence' : 'read_word'
    }
    // 创建音频环境
    try {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      this.audioContext.resume()
      if (!this.audioContext) {
        alert('浏览器不支持webAudioApi相关接口')
        return
      }
    } catch (e) {
      if (!this.audioContext) {
        alert('浏览器不支持webAudioApi相关接口')
        return
      }
    }

    // 获取浏览器录音权限
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
      .getUserMedia({
        audio: true,
        video: false,
      })
      .then(stream => {
        console.log('录音权限OK')
        if (testPermission) {
          getMediaSuccess(stream)
        } else {
          this.stop()
        }
      })
      .catch(e => {
        getMediaFail(e)
      })
    } else if (navigator.getUserMedia) {
      navigator.getUserMedia(
        {
          audio: true,
          video: false,
        },
        stream => {
          getMediaSuccess(stream)
        },
        function(e) {
          getMediaFail(e)
        }
      )
    } else {
      if (navigator.userAgent.toLowerCase().match(/chrome/) && location.origin.indexOf('https://') < 0) {
        alert('chrome下获取浏览器录音功能，因为安全性问题，需要在localhost或127.0.0.1或https下才能获取权限')
      } else {
        alert('无法获取浏览器录音功能，请升级浏览器或使用chrome')
      }
      this.audioContext && this.audioContext.close()
      return
    }
    // 获取浏览器录音权限成功的回调
    let getMediaSuccess = stream => {
      console.log('getMediaSuccess')
      //-音频合成相关赋值
      this.inputSampleRate = this.audioContext.sampleRate
      // 创建一个用于通过JavaScript直接处理音频
      this.scriptProcessor = this.audioContext.createScriptProcessor(0, 1, 1)
      this.scriptProcessor.onaudioprocess = e => {
        // 去处理音频数据
        if (this.status === 'ing') {
          //-音频合成相关数据
          this.input(e.inputBuffer.getChannelData(0))
          transWorker.postMessage(e.inputBuffer.getChannelData(0))
        }
      }
      // 创建一个新的MediaStreamAudioSourceNode 对象，使来自MediaStream的音频可以被播放和操作
      this.mediaSource = this.audioContext.createMediaStreamSource(stream)
      console.log('mediaSource:', this.mediaSource)
      // 连接
      this.mediaSource.connect(this.scriptProcessor)
      this.scriptProcessor.connect(this.audioContext.destination)
      this.connectWebSocket()
    }

    let getMediaFail = (e) => {
      alert('请求麦克风失败')
      console.log(e)
      this.audioContext && this.audioContext.close()
      this.audioContext = undefined
      // 关闭websocket
      if (this.webSocket && this.webSocket.readyState === 1) {
        this.webSocket.close()
      }
      submitErrorLog('getMediaFail-请求麦克风失败', e || '请求麦克风失败')
    }
  }
  recorderStart() {
    try {
      if (!this.audioContext) {
        this.recorderInit()
        console.log('init')
      } else {
        this.audioContext.resume()
        this.connectWebSocket()
      }
    } catch (e) {
      submitErrorLog('recorderStart-开始录音失败', e || '开始录音失败')
      throw new Error('开始录音失败')
    }
  }
  // 暂停录音
  recorderStop() {
    try {
      // safari下suspend后再次resume录音内容将是空白，设置safari下不做suspend
      if (!(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))){
        this.audioContext && this.audioContext.suspend()
      }
      this.setStatus('end')
    } catch (e) {
      submitErrorLog('recorderStop-结束录音失败', e || '结束录音失败')
      throw new Error('结束录音失败')
    }
  }

  // 对处理后的音频数据进行base64编码
  toBase64(buffer) {
    var binary = ''
    var bytes = new Uint8Array(buffer)
    var len = bytes.byteLength
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    return window.btoa(binary)
  }
  // 向webSocket发送数据
  webSocketSend() {
    if (this.webSocket.readyState !== 1) {
      return
    }
    let audioData = this.audioData.splice(0, 1280)
    var params = {
      common: {
        app_id: this.appId,
      },
      business: {
        category: this.category || 'read_sentence', // read_syllable/单字朗读，汉语专有 read_word/词语朗读  read_sentence/句子朗读 https://www.xfyun.cn/doc/Ise/IseAPI.html#%E6%8E%A5%E5%8F%A3%E8%B0%83%E7%94%A8%E6%B5%81%E7%A8%8B
        rstcd: 'utf8',
        group: 'pupil',
        sub: 'ise',
        tte: 'utf-8',
        cmd: 'ssb',
        auf: 'audio/L16;rate=16000',
        ent: 'en_vip',
        aus: 1,
        aue: 'raw',
        // text: '\uFEFF' + ($('.start-taste-left .ipt').val() || 'where are you')
        text: '\uFEFF' + this.text
      },
      data: {
        status: 0,
        encoding: 'raw',
        data_type: 1,
        data: this.toBase64(audioData),
      },
    }
    this.webSocket.send(JSON.stringify(params))
    this.handlerInterval = setInterval(() => {
      // websocket未连接
      if (this.webSocket.readyState !== 1) {
        this.audioData = []
        clearInterval(this.handlerInterval)
        return
      }
      // 最后一帧
      if (this.audioData.length === 0) {
        if (this.status === 'end') {
          this.webSocket.send(
            JSON.stringify({
              business: {
                cmd: 'auw',
                aus: 4,
                aue: 'raw'
              },
              data: {
                status: 2,
                encoding: 'raw',
                data_type: 1,
                data: '',
              },
            })
          )
          this.audioData = []
          clearInterval(this.handlerInterval)
        }
        return false
      }
      audioData = this.audioData.splice(0, 1280)
      // 中间帧
      this.webSocket.send(
        JSON.stringify({
          business: {
            cmd: 'auw',
            aus: 2,
            aue: 'raw'
          },
          data: {
            status: 1,
            encoding: 'raw',
            data_type: 1,
            data: this.toBase64(audioData),
          },
        })
      )
    }, 40)
  }
  result(resultData) {
    // 识别结束
    let jsonData = JSON.parse(resultData)
    if (jsonData.data && jsonData.data.data) {
      let data = Base64.decode(jsonData.data.data)
      let grade = parser.parse(data, {
        attributeNamePrefix: '',
        ignoreAttributes: false
      })
      this.setResultText(grade)
    }
    if (jsonData.code === 0 && jsonData.data.status === 2) {
      this.webSocket.close()
    }
    if (jsonData.code !== 0) {
      this.webSocket.close()
      console.log(`${jsonData.code}:${jsonData.message}`)
    }
  }
  start() {
    this.recorderStart()
    // this.setResultText()
    // $('.accuracy_score').text(0)
    // $('.emotion_score').text(0)
    // $('.fluency_score').text(0)
    // $('.integrity_score').text(0)
    // $('.phone_score').text(0)
    // $('.tone_score').text(0)
    // $('.total_score').text(0)
  }
  stop() {
    this.recorderStop()
  }
  //-音频合成相关方法：start

  input(data) {
    this.buffer.push(new Float32Array(data));
    this.size += data.length;
  }
  compress() { //合并压缩
    try {
      //合并
      const data = new Float32Array(this.size)
      let offset = 0
      for (let i = 0; i < this.buffer.length; i++) {
        data.set(this.buffer[i], offset);
        offset += this.buffer[i].length;
      }
      //压缩
      let compression = parseInt(this.inputSampleRate / this.outputSampleRate)
      console.log('压缩率', this.inputSampleRate, this.outputSampleRate)
      if (compression < 1) {
        compression = 1
      }
      const length = data.length / compression
      const result = new Float32Array(length)
      let index = 0, j = 0
      while (index < length) {
        result[index] = data[j];
        j += compression;
        index++;
      }
      return result;
    } catch (error) {
      submitErrorLog('compress-音频合成失败', error)
      throw new Error('音频合成失败')
    }
  }
  encodeWAV() {
    let s
    const sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate)
    const sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits)
    const bytes = this.compress()
    const dataLength = bytes.length * (sampleBits / 8)
    const buffer = new ArrayBuffer(44 + dataLength)
    const data = new DataView(buffer)

    const channelCount = 1//单声道
    let offset = 0

    const writeString = function(str) {
      for (let i = 0; i < str.length; i++) {
        data.setUint8(offset + i, str.charCodeAt(i));
      }
    }

    // 资源交换文件标识符
    writeString('RIFF');
    offset += 4;
    // 下个地址开始到文件尾总字节数,即文件大小-8
    data.setUint32(offset, 36 + dataLength, true);
    offset += 4;
    // WAV文件标志
    writeString('WAVE');
    offset += 4;
    // 波形格式标志
    writeString('fmt ');
    offset += 4;
    // 过滤字节,一般为 0x10 = 16
    data.setUint32(offset, 16, true);
    offset += 4;
    // 格式类别 (PCM形式采样数据)
    data.setUint16(offset, 1, true);
    offset += 2;
    // 通道数
    data.setUint16(offset, channelCount, true);
    offset += 2;
    // 采样率,每秒样本数,表示每个通道的播放速度
    data.setUint32(offset, sampleRate, true);
    offset += 4;
    // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8
    data.setUint32(offset, channelCount * sampleRate * (sampleBits / 8), true);
    offset += 4;
    // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
    data.setUint16(offset, channelCount * (sampleBits / 8), true);
    offset += 2;
    // 每样本数据位数
    data.setUint16(offset, sampleBits, true);
    offset += 2;
    // 数据标识符
    writeString('data');
    offset += 4;
    // 采样数据总数,即数据总大小-44
    data.setUint32(offset, dataLength, true);
    offset += 4;
    // 写入采样数据
    if (sampleBits === 8) {
      for (let i = 0; i < bytes.length; i++, offset++) {
        let s = Math.max(-1, Math.min(1, bytes[i]))
        let val = s < 0 ? s * 0x8000 : s * 0x7FFF
        val = parseInt(255 / (65535 / (val + 32768)));
        data.setInt8(offset, val, true);
      }
    } else {
      for (let i = 0; i < bytes.length; i++, offset += 2) {
        s = Math.max(-1, Math.min(1, bytes[i]))
        data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
      }
    }
    // this.uploadFile(data)
    return new Blob([data], { type: 'audio/wav' });
  }
  //获取音频文件
  getBlob() {
    return this.encodeWAV();
  }
  getAudioLocalUrl() {
    const blob = this.getBlob()
    return window.URL.createObjectURL(blob)
  }

  setAudioUrl(obj, { filedName = 'url', ...param }) {
    const blob = this.getBlob()
    obj[filedName] = window.URL.createObjectURL(blob)
    this.uploadAudioFile(blob,param).then(res => {
      // console.log(res)
      obj[filedName] = res.data.url
    })
  }
  uploadAudioFile(blob,{ formDataBack = null }) {
    const fileName = 'WAV' + Date.now() + '.wav'
    const file = new File([blob], fileName, { type: blob.type })
    return new Promise((resolve,reject) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('business_id', zhlType.getBusinessId())
      formData.append('file_type', 'wav')
      formData.append('name', fileName)
      formData.append('compress_type', 0)
      formData.append('token', getCookie('token'))
      formData.append('filter_sensitive', 0)
      formData.append('folder_id', 0)
      formDataBack && formDataBack(formData)
      HttpFactory.upload(formData, res => {
        resolve(res)
      }, err => {
        reject(err)
      },true)
    })
  }
  //-音频合成相关方法：end
}
const iseRecorder = new IseRecorder()
export {
  iseRecorder
}
// ======================开始调用=============================
// var vConsole = new VConsole()
/*
let iseRecorder = new IseRecorder()
iseRecorder.recorderInit()
let countInterval
// 状态改变时触发
iseRecorder.onWillStatusChange = function(oldStatus, status) {
  // 可以在这里进行页面中一些交互逻辑处理：倒计时（语音评测支持180s）,录音的动画，按钮交互等
  // 按钮中的文字
  let text = {
    null: '开始识别', // 最开始状态
    init: '开始识别', // 初始化状态
    ing: '结束识别', // 正在录音状态
    end: '开始识别', // 结束状态
  }
  let senconds = 0
  $('.taste-button')
  .removeClass(`status-${oldStatus}`)
  .addClass(`status-${status}`)
  .text(text[status])
  if (status === 'ing') {
    $('hr').addClass('hr')
    $('.taste-content').hide()
    $('.start-taste').addClass('flex-display-1')
    // 倒计时相关
    countInterval = setInterval(()=>{
      senconds++
      let time = ''
      let second =  (senconds - Math.floor(senconds / 60) * 60)
      second < 10 ? second = '0' + second : ''
      time = '0' + Math.floor(senconds / 60) + ': ' + second
      $('.used-time').text(time)
      if (senconds >= 180) {
        this.stop()
        clearInterval(countInterval)
      }
    }, 1000)
  } else if (status === 'init') {
    $('.start-taste-right').show()
    $('.used-time').text('00：00')
  } else {
    $('.start-taste-right').hide()
    $('.taste-content').show()
    $('hr').removeClass('hr')
    clearInterval(countInterval)
  }
}
// 监听识别结果的变化
iseRecorder.onTextChange = function(grade) {
  console.log('iseRecorder.onTextChange==>',grade)
  console.log(JSON.stringify(grade))
  const readSentence =  grade?.xml_result?.read_sentence?.rec_paper?.read_chapter
  $('.accuracy_score').text(readSentence?.accuracy_score)
  $('.emotion_score').text(readSentence?.emotion_score)
  $('.fluency_score').text(readSentence?.fluency_score)
  $('.integrity_score').text(readSentence?.integrity_score)
  $('.phone_score').text(readSentence?.phone_score)
  $('.tone_score').text(readSentence?.tone_score)
  $('.total_score').text(readSentence?.total_score)
  let sentence = readSentence?.word ||[]
  let resultStr = ''
  sentence.forEach(item => {
    if (item?.word) {
      item.word.forEach(wt => {
        let flag = false
        if (wt.syll?.phone) {
          flag = wt.syll.phone.some(pt => pt?.perr_msg != 0)
        } else {
          wt.syll.forEach(st => {
            if (Array.isArray(st?.phone)) {
              flag = st.phone.some(pt => pt?.perr_msg != 0)
            }
          })
        }
        if (flag) {
          resultStr += `<span class="err">${wt.content}</span>`
        } else {
          resultStr += wt.content
        }
      })
    } else if (item?.syll) {
      let flag = false
      if (item.syll?.phone) {
        flag = item.syll.phone.some(pt => pt?.perr_msg != 0)
      } else {
        item.syll.forEach(st => {
          if (Array.isArray(st?.phone)) {
            flag = st.phone.some(pt => pt?.perr_msg != 0)
          }
        })
      }
      if (flag) {
        resultStr += `<span class="err">${item.content}</span>`
      } else {
        resultStr += item.content
      }
    }
  })
  resultStr && $('.right .title').show()
  $('.output-box .right .result').html(resultStr)
}
$('#taste_button, .taste-button').click(() => {
  if (iseRecorder.status === 'ing') {
    iseRecorder.stop()
  } else {
    iseRecorder.start()
  }
})
*/
